<template>
    <div class="content-wrapper">
        <div class="container">
            <div
            v-if="!itemLoaded"
            class="text-center"
            >
            <div class="loading-animation"/>
            </div>
            <div
            v-if="itemLoaded"
            class="row">
                <div class="col">
                    <div class="sinlge-product-wrap box-module">
                        <div class="row">
                            <div class="col-lg-6">
                                <ProductGallery :images="item.ImageURLs"/>
                            </div>
                            <div class="col-lg-6">
                                <div class="quick-view-content">
                                    <div class="product-info">
                                        <h2>{{ item.Description }}</h2>
                                    </div>
                                    <ul class="list-unstyled">
                                        <li v-if="item.Brand">
                                            <strong>Merk:</strong> {{ item.Brand }}
                                        </li>
                                        <li v-if="item.WarehouseID && isUserLoggedIn">
                                            <strong>Magazijn:</strong> {{ item.WarehouseID }}
                                        </li>
                                    </ul>
                                    <div
                                    v-if="isUserLoggedIn"
                                    class="quick-add-to-cart">
                                        <div class="modal-cart">
                                            <div>
                                                <label class="control-label">
                                                    Startdatum
                                                    <date-picker
                                                    v-model="start"
                                                    :config="datePickerStartOptions" />
                                                </label>
                                            </div>
                                            <div v-if="itemType !== 'Sales'">
                                                <label class="control-label">
                                                    Einddatum
                                                    <date-picker
                                                    v-model="end"
                                                    :config="datePickerEndOptions"/>
                                                </label>
                                            </div>
                                            <div class="quantity">
                                                <label>Hoeveelheid</label>
                                                <div class="cart-plus-minus">
                                                    <input
                                                    v-model="amount"
                                                    type="number"
                                                    name="amount"
                                                    min="1"
                                                    step="1"
                                                    class="input-box">
                                                </div>
                                            </div>
                                            <!-- <div class="" >
                                                <h4>
                                                    <span
                                                    v-if="availabilityMessage"
                                                    :class="availabilityClass"
                                                    class="badge"
                                                    >
                                                    {{ availabilityMessage }}
                                                    </span>
                                                    <br>
                                                    <span
                                                        style="white-space:initial"
                                                        v-if="nextAvailabilityMessage"
                                                        class="badge badge-warning mt-1 text-left">
                                                        {{nextAvailabilityMessage}}
                                                    </span>
                                                </h4>
                                            </div> -->
                                            <div class="alert" :class="availabilityClass" role="alert">
                                                {{availabilityMessage}}
                                            </div>
                                            <div v-if="nextAvailabilityMessage" class="alert alert-warning" role="alert">
                                                {{nextAvailabilityMessage}}
                                            </div>
                                            <button
                                            :class="shoppingButtonClass"
                                            :disabled="!isAvailable"
                                            class="btn btn-primary"
                                            @click="addCartItem()">In winkelwagen</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="product-info-detailed">
                                    <div class="discription-tab-menu">
                                        <ul
                                        role="tablist"
                                        class="nav">
                                            <li class="active">
                                                <a
                                                href="#description"
                                                data-toggle="tab"
                                                class="active show">Omschrijving</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="discription-content">
                                    <div class="tab-content">
                                        <div
                                        id="description"
                                        class="tab-pane fade in active show"
                                        >
                                            <div class="description-content">
                                                <p v-html="item.Notes" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ItemService from '@/services/ItemService.js'
import CartService from '@/services/CartService.js'
import TranslationService from '@/services/TranslationService'
import AuthorizationService from '@/services/AuthorizationService'
import datePicker from 'vue-bootstrap-datetimepicker'
import moment from 'moment'
import swal from 'sweetalert'
import ProductGallery from '../Global/ProductGallery'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

require('moment/locale/nl')
require('vue-moment')

export default {
    components: {
        datePicker,
        ProductGallery
    },
    data () {
        return {
            item: null,
            itemType: 'Sales',
            amount: 1,
            start: moment().format('DD-MM-YYYY'),
            end: moment().add(1, 'days').format('DD-MM-YYYY'),
            datePickerStartOptions: {
                format: 'DD-MM-YYYY',
                useCurrent: false,
                minDate: moment(),
                defaultDate: moment()
            },
            datePickerEndOptions: {
                format: 'DD-MM-YYYY',
                useCurrent: false,
                minDate: moment().add(1, 'days'),
                defaultDate: moment().add(1, 'days')
            },
            itemLoaded: false,
            isAvailable: false,
            availabilityMessage: 'Niet voldoende voorraad.',
            availabilityClass: 'alert-danger',
            nextAvailabilityMessage: '',
            shoppingButtonClass: '',
            isUserLoggedIn: false
        }
    },
    watch: {
        amount: function (value) {
            value === '' ? this.setAvailable(false) : this.getAvailabilityForPeriod()
        },
        start: function (value) {
            value === '' ? this.setAvailable(false) : this.getAvailabilityForPeriod()
            this.checkDateSelectionProblems()
        },
        end: function (value) {
            value === '' ? this.setAvailable(false) : this.getAvailabilityForPeriod()
            this.checkDateSelectionProblems()
        }
    },
    created () {
        this.setup()
    },
    methods: {
        async getItem () {
            let itemID = this.$route.params.itemID
            this.item = await ItemService.getItem(itemID)
            if (this.item && this.item.ItemType) {
                this.itemType = this.item.ItemType
            } else {
                this.$router.push('products')
            }
        },
        async getAvailabilityForPeriod () {
            this.isAvailable = false
            let item = {
                itemID: this.item.ID,
                start: moment(this.start, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                end: moment(this.end, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                amount: parseInt(this.amount)
            }
            item.amount += await CartService.getCurrentCartItemAmount(item)
            let sufficientStock = await CartService.checkSufficientStock(item)
            this.setAvailable(sufficientStock)
        },

        async addCartItem () {
            let cartItem = {
                itemID: this.item.ID,
                itemDescription: this.item.Description,
                item: this.item,
                amount: parseInt(this.amount),
                start: moment(this.start, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                end: moment(this.end, 'DD-MM-YYYY').format('YYYY-MM-DD')
            }
            if (this.item.ItemType === 'Sales') {
                cartItem.end = ''
            }
            if (this.checkDateSelectionProblems() !== false) {
                let cartItemID = await CartService.addCartItem(cartItem)
                this.showContinueShoppingPopup(cartItemID)
            }
        },

        async setup () {
            await this.getItem()
            let isUserLoggedIn = await AuthorizationService.isUserLoggedIn()
            if (isUserLoggedIn) {
                this.isUserLoggedIn = true
                await this.getAvailabilityForPeriod()
            }

            this.itemLoaded = true
        },

        setAvailable (sufficientStock) {
            this.isAvailable = sufficientStock.HasStock
            this.availabilityMessage = this.isAvailable
                ? 'Op voorraad'
                : 'Niet voldoende voorraad.'
            this.availabilityClass = this.isAvailable
                ? 'alert-success'
                : 'alert-danger'
            this.shoppingButtonClass = this.isAvailable
                ? 'alert-primary'
                : ''
            let date = sufficientStock.NextStock != null ? moment(sufficientStock.NextStock).format('DD-MM-YYYY') : ', is niet bekend'

            // let date = moment(sufficientStock.NextStock).format('DD-MM-YYYY')
            this.nextAvailabilityMessage = this.isAvailable ? null : `De eerstvolgende datum waarop dit product beschikbaar is ${date}.`
        },

        showContinueShoppingPopup (cartItemID) {
            let _this_ = this
            let popup = {
                text: TranslationService.get('ITEM_PUT_IN_CART'),
                icon: 'success',
                buttons: {
                    continue_shopping: {
                        text: TranslationService.get('CONTINUE_SHOPPING'),
                        value: 'continue_shopping'
                    },
                    to_cart: {
                        text: TranslationService.get('TO_CART'),
                        value: 'to_cart'
                    }
                }
            }

            swal(popup).then(value => {
                if (value === 'continue_shopping') {
                    _this_.$router.push({ name: 'products' })
                } else if (value === 'to_cart') {
                    _this_.$router.push({
                        name: 'cart',
                        params: { toegevoegd: cartItemID }
                    })
                } else {
                    this.getAvailabilityForPeriod()
                }
            })
        },

        checkDateSelectionProblems () {
            setTimeout(
                function () {
                    // Check if end is smaller then start date, and change it to start date + 1 day if it is the case
                    if (
                        moment(this.start, 'DD-MM-YYYY') >=
                        moment(this.end, 'DD-MM-YYYY')
                    ) {
                        this.end = moment(this.start, 'DD-MM-YYYY')
                            .add('days', 1)
                            .format('DD-MM-YYYY')
                    }

                    // Set min End date to Start date + 1 day
                    this.datePickerEndOptions.minDate = moment(
                        this.start,
                        'DD-MM-YYYY'
                    ).add('days', 1)
                }.bind(this),
                300
            )
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Products/SingleItem.vue